import { BadgeCheck, Trophy, Zap, Sparkles, Flame } from "lucide-react";

const ICONS = {
  verified: BadgeCheck,
  top_rated: Trophy,
  fast_responder: Zap,
  new: Sparkles,
  most_booked: Flame,
};

// Colour system per badge tone. Kept small and elegant — no rainbow.
const TONES = {
  blue: "bg-[#2563EB]/8 text-[#2563EB] border-[#2563EB]/20",
  amber: "bg-amber-50 text-amber-700 border-amber-200",
  green: "bg-emerald-50 text-emerald-700 border-emerald-200",
  purple: "bg-violet-50 text-violet-700 border-violet-200",
  slate: "bg-slate-100 text-slate-700 border-slate-200",
};

// -----------------------------------------------------------------------------
// CoachBadges
// -----------------------------------------------------------------------------
// Compact pill list. Two sizes:
//   • variant="card"    → very small, no icons trick, up to 3 pills.
//   • variant="profile" → medium, icons + labels, tooltip via title.
// -----------------------------------------------------------------------------
export default function CoachBadges({ badges, variant = "card", max, className = "" }) {
  const list = (badges || []).filter(Boolean);
  if (list.length === 0) return null;
  const limit = max ?? (variant === "card" ? 2 : 6);
  const shown = list.slice(0, limit);

  return (
    <div
      className={`flex flex-wrap gap-1.5 ${className}`}
      data-testid={`coach-badges-${variant}`}
    >
      {shown.map((b) => {
        const Icon = ICONS[b.key] || BadgeCheck;
        const tone = TONES[b.tone] || TONES.slate;
        if (variant === "card") {
          return (
            <span
              key={b.key}
              title={b.why || b.label}
              data-testid={`coach-badge-${b.key}`}
              className={`inline-flex items-center gap-1 h-6 px-2 rounded-full text-[10.5px] font-semibold border ${tone}`}
            >
              <Icon className="w-3 h-3" strokeWidth={2.4} />
              {b.label}
            </span>
          );
        }
        return (
          <span
            key={b.key}
            title={b.why || b.label}
            data-testid={`coach-badge-${b.key}`}
            className={`inline-flex items-center gap-1.5 h-8 px-3 rounded-full text-[12.5px] font-semibold border ${tone}`}
          >
            <Icon className="w-3.5 h-3.5" strokeWidth={2.4} />
            {b.label}
          </span>
        );
      })}
    </div>
  );
}
